export { default } from './Table';